import React from 'react';
import '../styles/Header.css';

function Header() {
  return (
    <div className='header'>
      <h1 className='headerTitle'>Contador e Relógio</h1>
    </div>
  );
}

export default Header;
